import { auth } from "./index";

export async function authorizedFetch(
  url: string,
  init?: RequestInit,
): Promise<Response> {
  const token = await auth.getToken();
  return fetch(url, {
    ...init,
    headers: { ...init?.headers, Authorization: `Bearer ${token}` },
  });
}
